interface AbsolutePosition {
  x: number;
  y: number;
  width: number;
  height: number;
  left: number;
  top: number;
  right: number;
  bottom: number;
}

function getAbsolutePosition(element: HTMLElement): AbsolutePosition {
  let x = 0;
  let y = 0;
  let current: HTMLElement | null = element;

  while (current) {
    x += current.offsetLeft;
    y += current.offsetTop;
    current = current.offsetParent as HTMLElement | null;
  }

  return {
    x: x,
    y: y,
    width: element.offsetWidth,
    height: element.offsetHeight,
    left: x,
    top: y,
    right: x + element.offsetWidth,
    bottom: y + element.offsetHeight,
  };
}

function getRelativePosition(
  element: HTMLElement,
  absoluteX: number,
  absoluteY: number
): [x: number, y: number] {
  const offsetParent = element.offsetParent as HTMLElement | null;
  if (!element.offsetParent) {
    // If no offset parent, position is relative to document
    return [absoluteX, absoluteY];
  }

  let parentX = 0;
  let parentY = 0;
  let current: HTMLElement | null = offsetParent;
  while (current) {
    parentX += current.offsetLeft;
    parentY += current.offsetTop;
    current = current.offsetParent as HTMLElement | null;
  }

  return [absoluteX - parentX, absoluteY - parentY];
}

export function fallbackSetAnchorPosition(
  anchor: HTMLElement,
  item: HTMLElement
) {
  const anchorPos = getAbsolutePosition(anchor);
  const [x, y] = getRelativePosition(item, anchorPos.x, anchorPos.bottom);
  item.style.left = x + "px";
  item.style.top = y + "px";
}
